import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Text } from "../text";
import { jsx as ___EmotionJSX } from "@emotion/core";
var FlyoutTitleText = Text.withComponent('h2', {
  target: "e1uvemeu0"
});
FlyoutTitleText.defaultProps = _objectSpread(_objectSpread({}, Text.defaultProps), {}, {
  fontSize: 'T400',
  fontWeight: 'regular',
  color: 'neutral0',
  margin: 0
});
FlyoutTitleText.displayName = 'FlyoutTitleText';
export var defaultTitleRenderer = function defaultTitleRenderer(_ref) {
  var titleText = _ref.titleText;
  return ___EmotionJSX(FlyoutTitleText, null, titleText);
};